import React from "react";
import "./FilterInput.css";
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import SwapVertIcon from '@mui/icons-material/SwapVert';
import { useTranslation } from "react-i18next";
import type { TranslationKeys } from "../../../../i18n";
interface FilterInputProps {
  value?: string;
  placeholder?: string;
  onChange: (value: string) => void;
  onSort?: () => void;
  isSortable?: boolean;
  sortDirection?: "asc" | "desc";
  filterable?: boolean;
  hasCalendar?: boolean;
  onFilterClick?: (e: React.MouseEvent<HTMLSpanElement>) => void;
  onCalendarClick?: (e: React.MouseEvent<HTMLSpanElement>) => void;
  isFilterSelected?: boolean;
  hasAllFilters?: boolean;
  isActiveFilter?: boolean;
}

const FilterInput: React.FC<FilterInputProps> = ({
  value,
  placeholder,
  onChange,
  onSort,
  isSortable,
  sortDirection,
  filterable = false,
  hasCalendar = false,
  onFilterClick,
  onCalendarClick,
  isActiveFilter
}) => {
  const showSort = !!onSort;
  const rightPadding = filterable ? 48 : showSort ? 24 : 28;
  const { t } = useTranslation<TranslationKeys>();
  return (
    <div className="input-sort-wrapper">
      <input
        type="text"
        value={value}
        placeholder={placeholder || t("search")}
        onChange={(e) => onChange(e.target.value)}
        style={{ paddingRight: `${rightPadding}px` }}
      />

      {!hasCalendar &&filterable && (
        <span className="icon filter-icon" onClick={onFilterClick} >
  
          <FilterAltOutlinedIcon  style={{color:'grey'}}/>
          {isActiveFilter && (
            <span
              className="filter-dot"
              style={{
                position: "absolute",
                top: 2,
                right: 2,
                width: 8,
                height: 8,
                borderRadius: "50%",
                backgroundColor: "#c4262e", 
              }}
            />
          )}
        </span>
      )}
      {hasCalendar && (
        <span className="icon filter-icon" onClick={onCalendarClick}>
    
          <CalendarMonthOutlinedIcon style={{color:'grey'}}/>
        </span>
        
      )}
      
      {showSort && (
        <span
          className={`icon sort-icon ${
      hasCalendar || filterable   ? "with-filter" : ""
          } ${isSortable ? "active-sort" : ""}`}
          onClick={onSort}
        >
          <SwapVertIcon style={{color:'grey'}} className={isSortable ? `sorted-${sortDirection}` : ""} />
        </span>
      )}
    </div>
  );
};

export default FilterInput;
